import Marquee from "react-fast-marquee";

const DEFAULT_ITEMS = [
  "Cuisine Portugaise",
  "J'aime la vie",
  "Expérience Unique",
  "Saveur & Âme",
];

export default function EditorialMarquee({ items = DEFAULT_ITEMS }) {
  const loop = Array(4).fill(items).flat();
  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-[#102C1F]/15 bg-[#F4F1EB] py-5"
    >
      <Marquee speed={22} gradient={false} pauseOnHover>
        {loop.map((item, i) => (
          <span
            key={i}
            className="mx-10 flex items-center gap-10 font-display text-lg uppercase tracking-[0.3em] text-[#102C1F]/75 md:text-xl"
          >
            {item}
            <span className="text-[#102C1F]/35">•</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
